"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var FocusManager = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(FocusManager, _PureComponent);

  var _super = _createSuper(FocusManager);

  function FocusManager() {
    var _this;

    (0, _classCallCheck2.default)(this, FocusManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.beforeActiveElement = _this.props.tabIndex != null && _this.props.tabIndex > -1 ? document.activeElement : null;

    _this.focusRef = function (element) {
      var tabIndex = _this.props.tabIndex;
      if (!element || tabIndex == null || tabIndex < 0) return;
      setTimeout(function () {
        element.tabIndex = tabIndex;
        element.focus();
      }, 60);
    };

    return _this;
  }

  (0, _createClass2.default)(FocusManager, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.beforeActiveElement && typeof this.beforeActiveElement.focus === 'function') this.beforeActiveElement.focus();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.focusRef);
    }
  }]);
  return FocusManager;
}(_react.PureComponent);

exports.default = FocusManager;
FocusManager.propTypes = process.env.NODE_ENV !== "production" ? {
  tabIndex: _propTypes.default.number,
  children: _propTypes.default.func.isRequired
} : {};